import Slider from 'rc-slider/lib/Slider';
import 'rc-slider/assets/index.css';
import './POSSlider.less';
import React from 'react';
interface Mark {
  [key: string]: any;
}

export interface Props {
  min?: number;
  max?: number;
  step?: number | null;
  marks: Mark;
  defaultValue?: number;
  value?: number;
  onChange?: (value: number | number[]) => void;
  trackStyle?: React.CSSProperties;
  railStyle?: React.CSSProperties;
  dotStyle?: React.CSSProperties;
  disabled?: boolean;
  className?: string;
  draggableTrack?: boolean;
  included?: boolean;
}
export const POSSlider = ({
  min = 0,
  max = 10,
  step,
  marks,
  value,
  defaultValue,
  onChange,
  trackStyle,
  railStyle,
  dotStyle,
  disabled,
  className,
  draggableTrack,
  included,
}: Props) => {
  const change = (changeEventValue: number | number[]) => {
    onChange && onChange(changeEventValue);
  };
  return (
    <Slider
      onChange={change}
      style={{ width: '100%' }}
      marks={marks}
      min={min}
      max={max}
      step={step}
      value={value}
      defaultValue={defaultValue}
      trackStyle={trackStyle}
      railStyle={railStyle}
      dotStyle={dotStyle}
      disabled={disabled}
      className={className}
      draggableTrack={!draggableTrack}
      included={included}
    />
  );
};
